import useDocument from 'modules/shared/hooks/useDocument'
import useUploadS3, { UploadFileProps } from './useUploadS3'
import { useMutation } from '@tanstack/react-query'

type UploadFileAsDocumentProps = UploadFileProps & { uuid?: string }

export default function useUploadAsDocument() {
  const { createOrUpdateDocument } = useDocument()
  const { uploadFile } = useUploadS3()

  const mutationFn = async ({
    file,
    fileType,
    uuid
  }: UploadFileAsDocumentProps) => {
    const { content, url } = await uploadFile({ file, fileType })

    const { document, statusDes, statusUuid } = await createOrUpdateDocument({
      uuid,
      content_type: content.type,
      url,
      complement: JSON.stringify({ size: content.size })
    })

    return { document, statusDes, statusUuid, content, url }
  }

  const {
    mutateAsync: uploadFileAsDocument,
    error,
    data
  } = useMutation({
    mutationFn
  })

  return {
    data,
    error,
    uploadFileAsDocument
  }
}
